import { put, takeLatest } from 'redux-saga/effects';
import { SpaceTabId } from 'api/models';
import { Space, SpaceAPI } from 'api/space/space';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { rlNavigation } from 'utils/navigation';
import { getSpaceTabDetailUrl } from 'utils/urls';
import { CreateSpacePayload, createSpaceSagaAction } from '../actions';
import { createStart, createSuccess } from '../index';

function* createSpaceSaga(action: StoreActionProps<CreateSpacePayload>) {
  const { payload } = action;

  try {
    const {
      project: { projectId },
    } = payload;

    yield put(createStart());
    const response = (yield SpaceAPI.createSpace(payload)) as Space;

    yield put(createSuccess(response));
    yield rlNavigation.push(
      getSpaceTabDetailUrl(SpaceTabId(projectId, response.spaceId, 'new')),
    );
  } catch (error) {
    logger.error('createSpace failed', { error });
  }
}

export function* watchCreateSpaceSaga(): Generator {
  yield takeLatest(createSpaceSagaAction.type, createSpaceSaga);
}
